import Logger from '../../functions/logging';

import { 
	SET_CURRENT_USER, 
	SET_CURRENT_USER_LOCATION, 
	SET_USER_MONITOR, 
	ADD_STUDY_TO_MY_LIST, 
	SET_PILOTLY_POINTS, 
	SET_USER_DISCLAIMER 
} from '../actions/constants';

const INITIAL_STATE = {};

export default function (state = INITIAL_STATE, action) {
	Logger.log("currentUser.js REDUCER()", action.type);

	switch (action.type) {
		case SET_CURRENT_USER:
			return { ...state, currentUser: action.currentUser };
		case SET_CURRENT_USER_LOCATION:
			return { ...state, currentUserLocation: action.location };
		case SET_USER_DISCLAIMER:
			return { ...state, userDisclaimer: action.userDisclaimer };
		case SET_USER_MONITOR:
			return { ...state, userMonitor: action.userMonitor };
		case ADD_STUDY_TO_MY_LIST: {
			if (!action.study) {
				return state;
			}

			let currentUser = { ...state.currentUser };

			let userData = {
				complete: 0,
				group_id: action.study._id.valueOf(),
				mylist: 1,
				screened: 0,
				status: 1
			};

			// Update user's subscription list
			if (currentUser) {
				if (!currentUser.subscriptions) {
					currentUser.subscriptions = {};
				}
				if (!currentUser.subscriptions.list) {
					currentUser.subscriptions.list = [];
				}
				let found = false;
				for (let i = 0; i < currentUser.subscriptions.list.length; i++) {
					let item = currentUser.subscriptions.list[i];
					if (item.group_id.valueOf() === action.study._id.valueOf()) {
						found = true;
						item.mylist = 1;
						userData = item;
						break;
					}
				}
				if (!found) {
					currentUser.subscriptions.list.unshift(userData);
				}
			}

			return { ...state, currentUser };
		}
		case SET_PILOTLY_POINTS:
			return { ...state, userPilotlyPoints: action.pointTotal}
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/currentUser.js